import React from 'react';
import { Search, X } from 'react-feather';
import "./MobileSearchButton.scss";

const MobileSearchButton = ({searching, onClick}) => {
	return <div id="mobile-search-button" onClick={onClick} className={searching ? "searching" : ""}>{searching ? <X size={24} /> : <Search size={24} />}</div>;
}

export default MobileSearchButton;